// Mock data for chat responses (will be replaced with real LLM)
export const mockChatResponses = (userMessage) => {
  const message = userMessage.toLowerCase();

  if (message.includes('price') || message.includes('cost') || message.includes('quote')) {
    return "Our pricing varies based on your specific needs. I'd recommend requesting a quote through our website for a detailed estimate. Would you like me to help you with that?";
  }

  if (message.includes('network') || message.includes('wifi')) {
    return "We specialize in office network architecture and secure Wi-Fi design! We can help you build a robust, scalable network infrastructure. Would you like to schedule a consultation?";
  }

  if (message.includes('microsoft') || message.includes('365') || message.includes('office')) {
    return "Yes, we provide Microsoft 365 setup, migration, and ongoing support. We can help you transition smoothly and train your team. What specific M365 services are you interested in?";
  }

  if (message.includes('security') || message.includes('cybersecurity')) {
    return "Cybersecurity is one of our core services. We offer endpoint protection, network security, and ongoing monitoring. We can conduct a security assessment for your business. Interested?";
  }

  if (message.includes('support') || message.includes('help')) {
    return "We provide comprehensive IT support including system administration and end-user support. Our team is available to keep your systems running smoothly. What kind of support do you need?";
  }

  if (message.includes('hello') || message.includes('hi') || message.includes('hey')) {
    return "Hello! How can I assist you with your IT needs today? Feel free to ask about our services, pricing, or schedule a consultation.";
  }

  if (message.includes('thank')) {
    return "You're welcome! If you have any other questions, feel free to ask. I'm here to help!";
  }

  // Default response for unmatched queries
  return "I'm not quite sure about that, but I'd be happy to connect you with our team. You can reach us at info@cybertektechnology.com or request a quote through our website. Is there anything else I can help you with?";
};

// Client testimonials
export const testimonials = [
  {
    id: 1,
    name: 'Jacqueline Moreau',
    company: 'Pacific Coast Medical Group',
    role: 'IT Project Director',
    text: 'CyberTek transformed our network infrastructure across two clinic locations. Their expertise and professionalism are unmatched — every deadline was met and downtime was zero.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Steven Willows',
    company: 'Harborline Logistics',
    role: 'IT Operations Manager',
    text: 'Outstanding service! They designed and set up our new office network and secure Wi-Fi seamlessly. Our team was up and running on day one. Highly recommend for any business.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Priya Raghavan',
    company: 'Meridian Law Partners',
    role: 'Director of Administration',
    text: 'Professional, responsive, and knowledgeable. From our Microsoft 365 migration to ongoing support, CyberTek has been our go-to for all IT needs.',
    rating: 5,
  },
];
